<template>
<Box  @close="cerrar(false)">
    <template #top>Transferencias</template>
    <template #center>
        <div class="nj-card">
            <b-table :data="lista_transferencia_items_detalle" :sort-icon="sortIcon" :sort-icon-size="sortIconSize">
                <template slot-scope="props">
                    <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                    <b-table-column label="Cantidad" header-class="is-info" style="width: 100px;">{{ props.row.oci_cantidad }}</b-table-column>
                    <b-table-column label="Cantidad transferida" header-class="is-info" style="width: 100px;">{{ props.row.tid_cantidad }}</b-table-column>
                    <b-table-column label="Cantidad confirmada" header-class="is-info" style="width: 100px;">{{ props.row.tid_imgreso_cantidad }}</b-table-column>
                </template>
            </b-table>
        </div>
    </template>
</Box>
</template>

<script>
import { TransferenciaItemsService } from "../../services"
import Toast from "../../util/toast"
import { Box, LabelGroup } from "../components"

export default {
    name: "TransferenciaItemsDetallexOrdenView",
    components: {
        LabelGroup,
        Box,
    },
    props: {
        ord_id: {
            type: Number
        }
    },
    data() {
        return {
            lista_transferencia_items_detalle: [],
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
        }
    },
    methods: {
        cerrar(condition) {
            this.$emit("close", condition)
        },
        buscar() {
            TransferenciaItemsService.buscarDetallexOrden({
                ord_id: this.ord_id
            }).then(
                response => {
                    this.lista_transferencia_items_detalle = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
    },
    mounted() {
        this.buscar()
    }
}
</script>

<style scoped></style>